<template>
  <div class="isup-person-face-container">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <div slot="header"><span>门禁人脸</span></div>
      <el-row :gutter="12">
        <el-col :span="6">
          <el-select v-model="searchForm.personType" placeholder="人员类型" clearable>
            <el-option label="业主/家庭成员" value="OWNER" />
            <el-option label="员工" value="STAFF" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input v-model="searchForm.personName" placeholder="姓名/电话/编号" clearable />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 人员人脸列表 -->
    <el-card>
      <el-button type="primary" style="margin-bottom:12px" @click="openAddDialog">添加门禁人脸</el-button>
      <el-table v-loading="loading" :data="tableData" border>
        <el-table-column label="人员类型" width="110" align="center">
          <template slot-scope="scope">{{ scope.row.personType === 'OWNER' ? '业主' : '员工' }}</template>
        </el-table-column>
        <el-table-column prop="personName" label="姓名" min-width="100" />
        <el-table-column prop="personId" label="人员编号" min-width="160" />
        <el-table-column prop="faceVersion" label="人脸版本" width="80" align="center" />
        <el-table-column label="目标门禁" width="80" align="center">
          <template slot-scope="scope">{{ scope.row.targetMachineCount || 0 }}</template>
        </el-table-column>
        <el-table-column label="成功" width="60" align="center">
          <template slot-scope="scope">
            <el-tag type="success" size="mini">{{ scope.row.successCount || 0 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="待同步" width="70" align="center">
          <template slot-scope="scope">
            <el-tag type="warning" size="mini">{{ scope.row.pendingCount || 0 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="失败/重试" width="80" align="center">
          <template slot-scope="scope">
            <el-tag type="danger" size="mini">{{ scope.row.failedCount || 0 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="最后更新" min-width="160" />
        <el-table-column label="操作" width="220" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="openSyncDetail(scope.row)">同步详情</el-button>
            <el-button
              size="mini" type="warning"
              @click="retryAll(scope.row)"
              :disabled="(scope.row.failedCount || 0) + (scope.row.pendingCount || 0) === 0"
            >重试全部</el-button>
            <el-button size="mini" type="danger" @click="revokeFace(scope.row)">撤销</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page.sync="pagination.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <!-- 添加/替换人脸对话框 -->
    <el-dialog
      :title="faceDialog.isEdit ? '替换门禁人脸' : '添加门禁人脸'"
      :visible.sync="faceDialog.visible"
      width="520px"
      @closed="resetFaceDialog"
    >
      <el-form label-width="100px">
        <el-form-item label="选择人员">
          <el-button type="primary" size="small" @click="openPersonSelector">
            {{ faceDialog.personId ? faceDialog.personName + '（' + faceDialog.personId + '）' : '点击选择人员' }}
          </el-button>
        </el-form-item>
        <el-form-item v-if="faceDialog.personId" label="人员类型">
          <el-tag>{{ faceDialog.personType === 'OWNER' ? '业主/家庭成员' : '员工' }}</el-tag>
        </el-form-item>
        <el-form-item label="人脸上传" v-if="faceDialog.personId">
          <input
            ref="faceFileInput"
            type="file"
            accept="image/jpeg,image/jpg,image/png"
            @change="handleFaceFileChange"
          />
          <div style="margin-top:8px;color:#909399;font-size:12px">支持 JPG/PNG，不超过 2MB，单人正面清晰照</div>
        </el-form-item>
        <el-form-item v-if="faceDialog.previewUrl" label="预览">
          <img :src="faceDialog.previewUrl" style="max-width:200px;max-height:200px;border:1px solid #eee" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="faceDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" :disabled="!faceDialog.photoBase64"
          @click="submitFace">保存并同步到门禁</el-button>
      </span>
    </el-dialog>

    <!-- 人员选择器对话框 -->
    <el-dialog
      title="选择人员"
      :visible.sync="personDialog.visible"
      width="700px"
    >
      <el-row :gutter="12" style="margin-bottom:12px">
        <el-col :span="6">
          <el-select v-model="personDialog.personType" placeholder="人员类型" clearable>
            <el-option label="业主/家庭成员" value="OWNER" />
            <el-option label="员工" value="STAFF" />
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-input v-model="personDialog.keyword" placeholder="姓名/电话/编号" clearable @keyup.enter.native="searchPersons" />
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="searchPersons">搜索</el-button>
        </el-col>
      </el-row>
      <el-table v-loading="personDialog.loading" :data="personDialog.list" border max-height="350">
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">{{ scope.row.personType === 'OWNER' ? '业主' : '员工' }}</template>
        </el-table-column>
        <el-table-column prop="personName" label="姓名" min-width="100" />
        <el-table-column prop="personId" label="编号" min-width="160" />
        <el-table-column prop="phone" label="手机号" min-width="120" />
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="selectPerson(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="personDialog.visible = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 门禁同步详情对话框 -->
    <el-dialog
      title="门禁同步详情"
      :visible.sync="syncDialog.visible"
      width="900px"
    >
      <div style="margin-bottom:12px">
        <strong>{{ syncDialog.personName }}</strong>（{{ syncDialog.personId }}）
        人脸版本 {{ syncDialog.faceVersion }}
      </div>
      <el-table v-loading="syncDialog.loading" :data="syncDialog.list" border max-height="400">
        <el-table-column prop="machineName" label="门禁名称" min-width="120" />
        <el-table-column prop="machineId" label="machineId" min-width="160" />
        <el-table-column label="在线" width="60" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.online === 'Y' ? 'success' : 'info'" size="mini">
              {{ scope.row.online === 'Y' ? '在线' : '离线' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="targetFaceVersion" label="目标版本" width="70" align="center" />
        <el-table-column prop="syncedFaceVersion" label="已同步版本" width="80" align="center" />
        <el-table-column label="动作" width="70" align="center">
          <template slot-scope="scope">{{ scope.row.action === 'UPSERT' ? '下发' : '撤销' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="syncStateTag(scope.row.state)" size="mini">{{ syncStateText(scope.row.state) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="attemptCount" label="尝试" width="50" align="center" />
        <el-table-column prop="lastErrorMessage" label="错误信息" min-width="150" show-overflow-tooltip />
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.state === '1300' || scope.row.state === '1400'"
              size="mini" type="warning" @click="retrySingle(scope.row)"
            >重试</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="syncDialog.total > 0"
        :current-page.sync="syncDialog.page"
        :page-size="syncDialog.size"
        :total="syncDialog.total"
        layout="total, prev, pager, next"
        style="margin-top:12px;text-align:right"
        @current-change="loadSyncDetailPage"
      />
      <span slot="footer">
        <el-button @click="syncDialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  searchFacePersons, savePersonFace, deletePersonFace,
  listPersonFaces, listPersonDeviceSyncs,
  retryPersonDeviceSync, retryPersonAllDevices
} from '@/api/machine/isupPersonFaceApi'

export default {
  name: 'IsupPersonFaceList',
  data() {
    return {
      loading: false,
      saving: false,
      searchForm: { personType: '', personName: '' },
      tableData: [],
      pagination: { current: 1, size: 10, total: 0 },
      faceDialog: {
        visible: false, isEdit: false,
        personType: '', personId: '', personName: '',
        photoBase64: '', previewUrl: ''
      },
      personDialog: {
        visible: false, loading: false,
        personType: '', keyword: '',
        list: []
      },
      syncDialog: {
        visible: false, loading: false,
        faceId: '', personName: '', personId: '', faceVersion: 0,
        list: [], page: 1, size: 10, total: 0
      }
    }
  },
  created() { this.getList() },
  methods: {
    async getList() {
      this.loading = true
      try {
        const q = { page: this.pagination.current, row: this.pagination.size }
        if (this.searchForm.personType) q.personType = this.searchForm.personType
        if (this.searchForm.personName) q.personName = this.searchForm.personName
        const result = await listPersonFaces(q)
        this.tableData = result.data || []
        this.pagination.total = result.total || 0
      } catch (e) {
        this.$message.error(e.message || '查询失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.current = 1; this.getList() },
    handleReset() { this.searchForm = { personType: '', personName: '' }; this.handleSearch() },
    handleSizeChange(size) { this.pagination.size = size; this.getList() },
    handleCurrentChange(page) { this.pagination.current = page; this.getList() },

    // 人员选择器
    openPersonSelector() { this.personDialog.visible = true; this.searchPersons() },
    async searchPersons() {
      this.personDialog.loading = true
      try {
        const data = await searchFacePersons({
          personType: this.personDialog.personType || undefined,
          keyword: this.personDialog.keyword || undefined
        })
        this.personDialog.list = (data && data.persons) || []
      } catch (e) {
        this.$message.error(e.message || '查询人员失败')
      } finally {
        this.personDialog.loading = false
      }
    },
    selectPerson(row) {
      this.faceDialog.personType = row.personType
      this.faceDialog.personId = row.personId
      this.faceDialog.personName = row.personName
      this.faceDialog.photoBase64 = ''
      this.faceDialog.previewUrl = ''
      this.faceDialog.isEdit = false
      this.personDialog.visible = false
    },

    // 人脸对话框
    openAddDialog() {
      this.faceDialog.visible = true
      this.faceDialog.isEdit = false
    },
    resetFaceDialog() {
      this.faceDialog = {
        visible: false, isEdit: false,
        personType: '', personId: '', personName: '',
        photoBase64: '', previewUrl: ''
      }
      if (this.$refs.faceFileInput) this.$refs.faceFileInput.value = ''
    },
    handleFaceFileChange(e) {
      const file = e.target.files[0]
      if (!file) return
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片不能超过 2MB')
        return
      }
      const reader = new FileReader()
      reader.onload = (ev) => {
        this.faceDialog.photoBase64 = ev.target.result
        this.faceDialog.previewUrl = ev.target.result
      }
      reader.readAsDataURL(file)
    },
    async submitFace() {
      if (!this.faceDialog.personId) { this.$message.error('请先选择人员'); return }
      if (!this.faceDialog.photoBase64) { this.$message.error('请上传人脸照片'); return }
      this.saving = true
      try {
        await savePersonFace({
          personType: this.faceDialog.personType,
          personId: this.faceDialog.personId,
          photo: this.faceDialog.photoBase64
        })
        this.$message.success('人脸已保存，正在同步到门禁')
        this.faceDialog.visible = false
        this.getList()
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.saving = false
      }
    },

    // 重试
    async retrySingle(row) {
      try {
        await retryPersonDeviceSync({ syncId: row.syncId })
        this.$message.success('已重新进入待同步')
        this.loadSyncDetailPage()
      } catch (e) {
        this.$message.error(e.message || '重试失败')
      }
    },
    async retryAll(row) {
      try {
        const result = await this.$confirm('确认为该人员的全部失败/待同步门禁重新进入同步？', '确认', {
          confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
        })
        if (result !== 'confirm') return
        const res = await retryPersonAllDevices({ personType: row.personType, personId: row.personId })
        this.$message.success(`已重试 ${res.count} 条记录`)
        this.getList()
      } catch (e) {
        if (e !== 'cancel') this.$message.error(e.message || '操作失败')
      }
    },
    async revokeFace(row) {
      try {
        const result = await this.$confirm(
          `确认撤销 ${row.personName}(${row.personId}) 的全部门禁人脸权限？此操作不可恢复。`, '确认撤销', {
          confirmButtonText: '确定撤销', cancelButtonText: '取消', type: 'warning'
        })
        if (result !== 'confirm') return
        const res = await deletePersonFace({ personType: row.personType, personId: row.personId })
        this.$message.success(`已生成 ${res.machineCount} 条撤销任务，正在从门禁移除`)
        this.getList()
      } catch (e) {
        if (e !== 'cancel') this.$message.error(e.message || '操作失败')
      }
    },

    // 同步详情
    async openSyncDetail(row) {
      this.syncDialog.visible = true
      this.syncDialog.faceId = row.faceId
      this.syncDialog.personName = row.personName
      this.syncDialog.personId = row.personId
      this.syncDialog.faceVersion = row.faceVersion
      this.syncDialog.page = 1
      this.syncDialog.list = []
      this.syncDialog.total = 0
      await this.loadSyncDetailPage()
    },
    async loadSyncDetailPage() {
      this.syncDialog.loading = true
      try {
        const result = await listPersonDeviceSyncs({
          faceId: this.syncDialog.faceId,
          page: this.syncDialog.page,
          row: this.syncDialog.size
        })
        this.syncDialog.list = result.data || []
        this.syncDialog.total = result.total || 0
      } catch (e) {
        this.$message.error(e.message || '查询同步详情失败')
      } finally {
        this.syncDialog.loading = false
      }
    },

    // 状态映射
    syncStateText(state) {
      return {
        '1000': '待同步', '1100': '同步中', '1200': '成功',
        '1300': '待重试', '1400': '失败', '1500': '待撤销',
        '1600': '已删除', '1700': '已取消'
      }[state] || state || '未知'
    },
    syncStateTag(state) {
      return {
        '1000': 'warning', '1100': '', '1200': 'success',
        '1300': 'danger', '1400': 'danger', '1500': 'warning',
        '1600': 'info', '1700': 'info'
      }[state] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.isup-person-face-container {
  padding: 20px;
  .search-card { margin-bottom: 20px; }
  .el-pagination { margin-top: 20px; text-align: right; }
}
</style>
